import gql from "graphql-tag";

export default gql`
  mutation previewBloombergJob($input: BloombergJobInput!) {
    previewBloombergJob(input: $input) {
      valid
      job {
        name
        identifiers
        category_ids
        request_kind
        schedule_id
        start_date
        end_date
        profile_id
        fields
        universe_hash
        definition_hash
      }
      issues {
        code
        message
        index
        identifier
      }
      duplicate_identifiers
      identifier_count
      field_count
      date_count
      requested_cells
      potential_history_fields
      unavailable_history_fields
      unverified_history_fields
      warnings
      execution_enabled
      storage_enabled
      policy_outcome
      plan_hash
      estimate_status
      new_request_count
      reusable_cells
    }
  }
`;